<template>
  <div class="inquiry">
    <!-- 主诉 -->
    <div class="zs-box">
      <p>主诉：</p>
      <el-input
          class="zs-input"
          v-model="postData.ChiefComplaint"
          placeholder="请输入主诉内容"
      ></el-input>
    </div>

    <!-- 症状（多选） -->
    <div class="zz-box">
      <p>症状：</p>
      <el-checkbox-group v-model="symptomsList">
        <el-checkbox label="眼累">眼累</el-checkbox>
        <el-checkbox label="眼胀">眼胀</el-checkbox>
        <el-checkbox label="重影">重影</el-checkbox>
        <el-checkbox label="串行">串行</el-checkbox>
        <el-checkbox label="畏光">畏光</el-checkbox>
        <el-checkbox label="看近后再看远模糊">看近后再看远模糊</el-checkbox>
        <el-checkbox label="从看远到看近需要反应">从看远到看近需要反应</el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- 健康状况（多选 + 备注输入框） -->
    <div class="jk-box">
      <div class="jkzk">
        <p>健康状况：</p>
        <el-checkbox-group v-model="healthList" @change="healthChange">
          <el-checkbox label="过敏史">过敏史</el-checkbox>
          <el-checkbox label="眼病史">眼病史</el-checkbox>
          <el-checkbox label="家族近视遗传史">家族近视遗传史</el-checkbox>
          <el-checkbox label="高血压">高血压</el-checkbox>
          <el-checkbox label="高血糖">高血糖</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="jkbz">
        <p>备注：</p>
        <el-input
            class="jk-note"
            v-model="postData.HealthNote"
            placeholder="请输入备注内容"
        ></el-input>
      </div>
    </div>

    <!-- 既往矫正方式（多选） -->

    <div class="jz-box">
      <p>既往矫正方式：</p>
      <el-checkbox-group v-model="correctList">
        <el-checkbox label="框架">框架</el-checkbox>
        <el-checkbox label="软性隐形眼镜">软性隐形眼镜</el-checkbox>
        <el-checkbox label="离焦">离焦</el-checkbox>
        <el-checkbox label="RGP">RGP</el-checkbox>
        <el-checkbox label="OK镜">OK镜</el-checkbox>
        <el-checkbox label="屈光手术">屈光手术</el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- 用眼场景（多选，每个选项关联输入框） -->
    <div class="cj-box">
      <p>用眼场景：</p>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.drive">驾驶</el-checkbox>
        <el-input
            v-show="sceneCheck.drive"
            class="cj-input"
            v-model="postData.SceneDrive"
            placeholder="请输入时长"
        ></el-input>
      </div>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.digital">电子数码</el-checkbox>
        <el-input
            v-show="sceneCheck.digital"
            class="cj-input"
            v-model="postData.SceneDigital"
            placeholder="请输入时长"
        ></el-input>
      </div>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.classroom">上课</el-checkbox>
        <el-input
            v-show="sceneCheck.classroom"
            class="cj-input"
            v-model="postData.SceneClass"
            placeholder="请输入时长"
        ></el-input>
      </div>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.sport">运动</el-checkbox>
        <el-input
            v-show="sceneCheck.sport"
            class="cj-input"
            v-model="postData.SceneSport"
            placeholder="请输入时长"
        ></el-input>
      </div>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.daily">日常</el-checkbox>
        <el-input
            v-show="sceneCheck.daily"
            class="cj-input"
            v-model="postData.SceneDaily"
            placeholder="请输入时长"
        ></el-input>
      </div>
      <div class="cj-item">
        <el-checkbox v-model="sceneCheck.travel">旅行户外</el-checkbox>
        <el-input
            v-show="sceneCheck.travel"
            class="cj-input"
            v-model="postData.SceneTravel"
            placeholder="请输入时长"
        ></el-input>
      </div>
    </div>

    <!-- 远中近用眼距离切换（多选） -->

    <div class="jl-box">
      <p>用眼距离切换：</p>
      <el-checkbox-group v-model="distanceList">
        <el-checkbox label="远">远</el-checkbox>
        <el-checkbox label="中">中</el-checkbox>
        <el-checkbox label="近">近</el-checkbox>
        <el-checkbox label="远中切换">远中切换</el-checkbox>
        <el-checkbox label="中近切换">中近切换</el-checkbox>
        <el-checkbox label="远近切换">远近切换</el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- 备注 -->
    <div class="qtjbs">
      <p>备注：</p>
      <el-input
          style="width: 60vw;"
          v-model="postData.Remark"
          placeholder="请输入内容"
      ></el-input>
    </div>

    <!-- 底部按钮 -->
    <div class="db">
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "adultInquiry",
  data() {
    return {
      symptomsList: [],
      healthList: [],
      correctList: [],
      sceneCheck: {
        drive: false,
        digital: false,
        classroom: false,
        sport: false,
        daily: false,
        travel: false
      },
      distanceList: [],
      postData: {
        ChiefComplaint: '',
        Symptoms: '',
        HealthStatus: '',
        HealthNote: '',
        CorrectMethod: '',
        SceneDrive: '',
        SceneDigital: '',
        SceneClass: '',
        SceneSport: '',
        SceneDaily: '',
        SceneTravel: '',
        SceneSelect: '',
        DistanceUse: '',
        Remark: ''
      }
    }
  },
  watch: {
    symptomsList: {
      handler(n) {
        this.postData.Symptoms = n.join(',')
      },
      immediate: true,
      deep: true
    },
    healthList: {
      handler(n) {
        this.postData.HealthStatus = n.join(',')
      },
      immediate: true,
      deep: true
    },
    correctList: {
      handler(n) {
        this.postData.CorrectMethod = n.join(',')
      },
      immediate: true,
      deep: true
    },
    sceneCheck: {
      handler(n) {
        let arr = []
        if (n.drive) arr.push('驾驶')
        if (n.digital) arr.push('电子数码')
        if (n.classroom) arr.push('上课')
        if (n.sport) arr.push('运动')
        if (n.daily) arr.push('日常')
        if (n.travel) arr.push('旅行户外')
        this.postData.SceneSelect = arr.join(',')
      },
      immediate: true,
      deep: true
    },
    distanceList: {
      handler(n) {
        this.postData.DistanceUse = n.join(',')
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    healthChange() {
      if (!this.healthList.includes('备注')) {
        this.postData.HealthNote = ''
      }
    },
    goBack() {
      this.$emit('back')
    },
    submit() {
      this.$emit('submit', JSON.parse(JSON.stringify(this.postData)))
    }
  }
}
</script>

<style scoped lang="scss">
.inquiry {
  width: 90%;
  margin: 0 auto;
}

h3 {
  padding: 20px 0 10px 0;
  text-align: left;
}

/* ========== 主诉 ========== */
.zs-box {
  text-align: left;
  display: flex;
  align-items: center;
  .zs-input {width: 60vw;}
  p {font-weight: 500;}
}

/* ========== 症状 ========== */
.zz-box {
  text-align: left;
  display: flex;
  align-items: center;
  padding: 30px 0;
  p {font-weight: 500;}
}

/* ========== 健康状况 ========== */
.jk-box {
  text-align: left;
  padding-bottom: 30px;
  .jkzk {
    display: flex;
    align-items: center;
    p {font-weight: 500;}
  }
  .jkbz {
    display: flex;
    align-items: center;
    .jk-note {
      width: 60vw;
      margin-top: 8px;
    }
  }

}

/* ========== 既往矫正方式 ========== */
.jz-box {
  text-align: left;
  display: flex;
  align-items: center;
  padding-bottom: 30px;
  p {font-weight: 500}
}

/* ========== 用眼场景 ========== */
.cj-box {
  text-align: left;
  display: flex;
  align-items: center;
  padding-bottom: 30px;
  flex-wrap: wrap;
  p {font-weight: 500;}
  .cj-item {
    display: flex;
    align-items: center;
    padding-right: 25px;
    //margin-bottom: 10px;
    .cj-input {
      width: 180px;
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
}

/* ========== 用眼距离切换 ========== */
.jl-box {
  text-align: left;
  display: flex;
  align-items: center;
  p {font-weight: 500;}
}

/* ========== 备注 ========== */
.qtjbs {
  text-align: left;
  padding-top: 30px;
  display: flex;
  align-items: center;
  h3 {
    padding: 20px 0 10px 0;
  }
}

/* ========== 底部按钮 ========== */
.db {
  padding: 50px 0 20px 0;
}
</style>
